import React, { createContext, useContext, useState, useCallback, ReactNode } from 'react';

interface ModalContextType {
  isAnyModalOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const ModalProvider = ({ children }: { children: ReactNode }) => {
  const [modalCount, setModalCount] = useState(0);

  const openModal = useCallback(() => {
    setModalCount(prev => prev + 1);
  }, []);

  const closeModal = useCallback(() => {
    setModalCount(prev => Math.max(0, prev - 1));
  }, []);

  const isAnyModalOpen = modalCount > 0;

  return (
    <ModalContext.Provider value={{ isAnyModalOpen, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export const useModal = () => {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};
